const colors = [
  '#000000',
  '#434343',
  '#666666',
  '#999999',
  '#cccccc',
  '#ffffff',
  '#ff0000',
  '#ff9900',
  '#ffff00',
  '#00ff00',
  '#00ffff',
  '#0000ff',
  '#9900ff',
  '#ff00ff',
  '#f4cccc',
  '#fce5cd',
  '#fff2cc',
  '#d9ead3',
  '#d0e0e3',
  '#cfe2f3',
  '#d9d2e9',
  '#ead1dc',
  '#ea9999',
  '#f9cb9c',
]

type ColorPickerProps = {
  onClick: (color: string) => void
}

export const ColorPicker = ({ onClick }: ColorPickerProps) => (
  <div className="absolute left-0 top-10 z-10 grid w-32 grid-cols-4 gap-2 rounded border border-solid border-gray-100 bg-white p-2 shadow-lg">
    {colors.map(color => (
      <button
        key={color}
        onClick={() => onClick(color)}
        className="h-5 w-5 cursor-pointer rounded border border-gray-300"
        style={{ backgroundColor: color }}
      />
    ))}
  </div>
)
